import React from "react"
import { Link } from "react-router-dom"
import { useTranslation } from "react-i18next"
import { ListChecks } from "lucide-react"
import { ModernButton } from "../../components/ui"
import { OperationSaleListPage } from "../operation/OperationSaleListPage"

const postSalesPipelineDetailPath = (saleId: string) => `/post-sales/pipeline/${saleId}`

export const PostSalesPipelineListPage: React.FC = () => {
 const { t } = useTranslation()
 return (
  <div className="space-y-4">
   <div className="flex justify-end">
    <Link to="/settings/operation-pipeline" className="inline-flex">
     <ModernButton type="button" variant="outline" size="sm">
      <ListChecks className="h-4 w-4 mr-2" />
      {t("nav.operationPipelineSettings")}
     </ModernButton>
    </Link>
   </div>
<OperationSaleListPage
     operationalStage="pre_sale"
     titleKey="postSalesPipeline.title"
     subtitleKey="postSalesPipeline.subtitle"
     progressStageKey="pre_sale"
     showAdvance={false}
     getSaleDetailPath={postSalesPipelineDetailPath}
    />
  </div>
 )
}
